export default "/images/2d211e5cebd5097bb25cd98a7f0221b2.avif";